export default __webpack_public_path__ + "static/media/xl.4a51eac8.jpg";